import { createBlock as n, openBlock as a, resolveDynamicComponent as s, normalizeClass as o, withCtx as i, renderSlot as u, createElementVNode as y, computed as l, unref as d, createElementBlock as p, createCommentVNode as v, createVNode as B } from "vue";
import { _ as g } from "./DIcon.js";
import { _ as S } from "./DLoader.js";
const k = {
  __name: "Base",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(s(e.tag), {
      class: o(["button-base-surface-default hover:button-base-surface-hover active:button-base-surface-active button-base-on-surface-neutral-default hover:button-base-on-surface-neutral-hover active:button-base-on-surface-neutral-active shadow-sm ring-1 ring-inset ring-(--button-base-border-default) hover:ring-(--button-base-border-hover) active:ring-(--button-base-border-active)", {
        "button-base-surface-hover! button-base-on-surface-neutral-hover! ring-(--button-base-border-hover)!": e.hover,
        "button-base-surface-active! button-base-on-surface-neutral-active! ring-(--button-base-border-active)!": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: i(() => [
        u(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, x = {
  __name: "Destructive",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(s(e.tag), {
      class: o(["button-destructive-primary-surface-default hover:button-destructive-primary-surface-hover active:button-destructive-primary-surface-active button-destructive-primary-on-surface-default hover:button-destructive-primary-on-surface-hover active:button-destructive-primary-on-surface-active shadow-sm focus-visible:outline-(--border-destructive-base)!", {
        "button-destructive-primary-surface-hover! button-destructive-primary-on-surface-hover!": e.hover,
        "button-destructive-primary-surface-active! button-destructive-primary-on-surface-active!": e.active,
        "button-base-surface-disabled! button-base-on-surface-neutral-default!": e.disabled
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: i(() => [
        u(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, w = {
  __name: "DestructiveSubtle",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(s(e.tag), {
      class: o(["button-destructive-subtle-surface-default hover:button-destructive-subtle-surface-hover active:button-destructive-subtle-surface-active button-destructive-subtle-on-surface-default hover:button-destructive-subtle-on-surface-hover active:button-destructive-subtle-on-surface-active shadow-sm focus-visible:outline-(--border-destructive-base)! ring-1 ring-inset ring-(--button-destructive-subtle-border-default) hover:ring-(--button-destructive-subtle-border-hover) active:ring-(--button-destructive-subtle-border-active)", {
        "button-destructive-subtle-surface-hover! button-destructive-subtle-on-surface-hover! ring-(--button-destructive-subtle-border-hover)!": e.hover,
        "button-destructive-subtle-surface-active! button-destructive-subtle-on-surface-active! ring-(--button-destructive-subtle-border-active)!": e.active,
        "ring-transparent! button-base-surface-disabled! button-base-on-surface-neutral-default!": e.disabled
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: i(() => [
        u(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, z = {
  __name: "InputAlias",
  props: {
    tag: String,
    active: Boolean,
    focused: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(s(e.tag), {
      class: o(["surface-input-default text-neutral-base ring-1 ring-inset ring-(--border-neutral-base) hover:ring-(--border-neutral-strong)", {
        "ring-2 ring-(--border-focus)!": e.focused || e.active,
        "opacity-50": e.disabled
      }]),
      "d-group-border": ""
    }, {
      default: i(() => [
        u(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}, $ = {
  __name: "Outline",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(s(e.tag), {
      class: o(["ring-1 ring-inset ring-(--button-outline-border-default) hover:ring-(--button-outline-border-hover) active:ring-(--button-outline-border-active) button-outline-surface-default hover:button-outline-surface-hover active:button-outline-surface-active button-outline-on-surface-default hover:button-outline-on-surface-hover active:button-outline-on-surface-active hover:overlay-subtle active:overlay-base shadow-sm active:outline active:outline-offset-2 active:outline-(--button-outline-border-default)", {
        "button-outline-surface-hover! button-outline-on-surface-hover! ring-(--button-outline-border-hover)! overlay-subtle!": e.hover,
        "button-outline-surface-active! button-outline-on-surface-active! ring-(--button-outline-border-active)! overlay-base! outline! outline-offset-2! outline-(--button-outline-border-default)!": e.active,
        "ring-(--button-base-border-default)! button-base-on-surface-neutral-default!": e.disabled
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: i(() => [
        u(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, T = {
  __name: "Brand",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(s(e.tag), {
      class: o(["button-brand-primary-surface-default hover:button-brand-primary-surface-hover active:button-brand-primary-surface-active button-brand-primary-on-surface-default hover:button-brand-primary-on-surface-hover active:button-brand-primary-on-surface-active shadow-sm", {
        "button-brand-primary-surface-hover! button-brand-primary-on-surface-hover!": e.hover,
        "button-brand-primary-surface-active! button-brand-primary-on-surface-active!": e.active,
        "button-base-surface-disabled! button-base-on-surface-neutral-default!": e.disabled
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: i(() => [
        u(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, C = {
  __name: "BrandSubtle",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(s(e.tag), {
      class: o(["button-brand-subtle-surface-default hover:button-brand-subtle-surface-hover active:button-brand-subtle-surface-active button-brand-subtle-on-surface-default hover:button-brand-subtle-on-surface-hover active:button-brand-subtle-on-surface-active shadow-sm ring-1 ring-inset ring-(--button-brand-subtle-border-default) hover:ring-(--button-brand-subtle-border-hover) active:ring-(--button-brand-subtle-border-active)", {
        "button-brand-subtle-surface-hover! button-brand-subtle-on-surface-hover! ring-(--button-brand-subtle-border-hover)!": e.hover,
        "button-brand-subtle-surface-active! button-brand-subtle-on-surface-active! ring-(--button-brand-subtle-border-active)!": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: i(() => [
        u(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, I = { class: "flex items-center text-superadmin" }, U = {
  __name: "Superadmin",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean,
    border: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    return (t, r) => (a(), n(s(e.tag), {
      class: o(["hover:button-transparent-surface-hover active:button-transparent-surface-active button-base-on-surface-neutral-default hover:button-base-on-surface-neutral-hover active:button-base-on-surface-neutral-active", {
        "button-transparent-surface-hover! button-base-on-surface-neutral-hover!": e.hover,
        "is-active button-transparent-surface-active! button-base-on-surface-neutral-active!": e.active,
        "shadow-sm button-superadmin": e.border
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: i(() => [
        y("span", I, [
          u(t.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["class", "disabled", "active"]));
  }
}, D = {
  __name: "TextLink",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean,
    linkColor: String,
    linkUnderline: Boolean,
    linkSize: String
  },
  setup(e) {
    const t = e, r = l(() => {
      switch (t.linkColor) {
        case "base":
          return "button-base-on-surface-neutral-default hover:button-base-on-surface-neutral-hover active:button-base-on-surface-neutral-active";
        case "superadmin":
          return "text-superadmin";
        case "destructive":
          return "button-transparent-on-surface-destructive-default hover:button-transparent-on-surface-destructive-hover active:button-transparent-on-surface-destructive-active";
        case "informative":
          return "button-transparent-on-surface-information-default hover:button-transparent-on-surface-information-hover active:button-transparent-on-surface-information-active";
        case "alert":
          return "button-transparent-on-surface-alert-default hover:button-transparent-on-surface-alert-hover active:button-transparent-on-surface-alert-active";
        case "success":
          return "button-transparent-on-surface-success-default hover:button-transparent-on-surface-success-hover active:button-transparent-on-surface-success-active";
        case "brand":
        default:
          return "button-transparent-on-surface-brand-default hover:button-transparent-on-surface-brand-hover active:button-transparent-on-surface-brand-active";
      }
    }), c = l(() => {
      switch (t.linkColor) {
        case "base":
          return "button-base-on-surface-neutral-hover!";
        case "superadmin":
          return "text-superadmin!";
        case "destructive":
          return "button-transparent-on-surface-destructive-hover!";
        case "informative":
          return "button-transparent-on-surface-information-hover!";
        case "alert":
          return "button-transparent-on-surface-alert-hover!";
        case "success":
          return "button-transparent-on-surface-success-hover!";
        case "brand":
        default:
          return "button-transparent-on-surface-brand-hover!";
      }
    }), f = l(() => {
      switch (t.linkColor) {
        case "base":
          return "button-base-on-surface-neutral-active!";
        case "superadmin":
          return "text-superadmin!";
        case "destructive":
          return "button-transparent-on-surface-destructive-active!";
        case "informative":
          return "button-transparent-on-surface-information-active!";
        case "alert":
          return "button-transparent-on-surface-alert-active!";
        case "success":
          return "button-transparent-on-surface-success-active!";
        case "brand":
        default:
          return "button-transparent-on-surface-brand-active!";
      }
    }), h = l(() => {
      switch (t.linkSize) {
        case "base":
          return "button-sm text-sm leading-5";
        case "lg":
          return "button-base leading-6";
        default:
          return "button-sm text-sm leading-5";
      }
    });
    return (m, b) => (a(), n(s(e.tag), {
      class: o(["hover:underline underline-offset-4", [d(r), d(h), {
        [d(f)]: e.active,
        "underline!": e.hover,
        [d(c)]: e.hover,
        underline: e.linkUnderline || e.active,
        "opacity-80! button-base-on-surface-neutral-default!": e.disabled
      }]]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: i(() => [
        u(m.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, j = {
  __name: "Transparent",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(s(e.tag), {
      class: o(["hover:button-transparent-surface-hover active:button-transparent-surface-active button-base-on-surface-neutral-default hover:button-base-on-surface-neutral-hover active:button-base-on-surface-neutral-active", {
        "button-transparent-surface-hover! button-base-on-surface-neutral-hover!": e.hover,
        "button-base-on-surface-neutral-active! button-transparent-surface-active!": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: i(() => [
        u(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, M = {
  __name: "TransparentSubtle",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(s(e.tag), {
      class: o(["button-transparent-subtle-on-surface-default hover:button-transparent-subtle-on-surface-hover active:button-transparent-subtle-on-surface-active", {
        "button-transparent-subtle-on-surface-hover!": e.hover,
        "button-transparent-subtle-on-surface-active!": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: i(() => [
        u(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, P = {
  __name: "TransparentSubtleInvert",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(s(e.tag), {
      class: o(["button-transparent-subtle-on-surface-invert-default hover:button-transparent-subtle-on-surface-invert-hover active:button-transparent-subtle-on-surface-invert-active", {
        "button-transparent-subtle-on-surface-invert-hover!": e.hover,
        "button-transparent-subtle-on-surface-invert-active!": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: i(() => [
        u(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, A = { class: "w-5 h-5 relative flex items-center justify-center" }, E = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center pointer-events-none"
}, O = {
  __name: "DButton",
  props: {
    tag: {
      type: String,
      default: "button",
      editable: !1
    },
    theme: {
      type: String,
      default: "brand",
      description: "Used to change the theme of the button",
      deprecated: ["primary", "primary-subtle", "secondary"],
      validator(e) {
        return [
          "primary",
          "brand",
          "primary-subtle",
          "brand-subtle",
          "base",
          "secondary",
          "destructive",
          "destructive-subtle",
          "text-link",
          "transparent",
          "transparent-subtle",
          "transparent-subtle-invert",
          "outline",
          "superadmin",
          "input-alias"
        ].includes(e);
      }
    },
    linkColor: {
      type: String,
      default: "brand",
      description: "Used to change the colour for text links",
      validator(e, t) {
        return [
          "base",
          "superadmin",
          "destructive",
          "informative",
          "alert",
          "success",
          "brand"
        ].includes(e);
      }
    },
    linkUnderline: {
      type: Boolean,
      default: !0,
      description: "Used to remove the underline from text links"
    },
    linkSize: {
      type: String,
      default: "base",
      description: "Used to change the size of text links",
      validator(e, t) {
        return [
          "base",
          "lg"
        ].includes(e);
      }
    },
    size: {
      type: String,
      default: "md",
      description: "Used to change the size of the button",
      validator(e, t) {
        return [
          "sm",
          "md",
          "lg"
        ].includes(e);
      }
    },
    dot: {
      type: Boolean,
      default: !1,
      description: "Displays a notification dot on the button"
    },
    icon: {
      type: String,
      description: "The icon to display on the button",
      iconify: !0
    },
    iconSet: {
      type: String,
      description: "The icon set to use"
    },
    iconType: {
      type: String,
      description: "The icon type to use"
    },
    iconSize: {
      type: String,
      default: "w-5 h-5",
      description: "The size of the icon"
    },
    leftIcon: {
      type: String,
      description: "The icon to display on the left of the button",
      iconify: !0
    },
    leftIconSet: {
      type: String,
      description: "The icon set to use for the left icon"
    },
    leftIconType: {
      type: String,
      description: "The icon type to use for the left icon"
    },
    rightIcon: {
      type: String,
      description: "The icon to display on the right of the button",
      iconify: !0
    },
    rightIconSet: {
      type: String,
      description: "The icon set to use for the right icon"
    },
    rightIconType: {
      type: String,
      description: "The icon type to use for the right icon"
    },
    wide: {
      type: Boolean,
      description: "Makes the button full width"
    },
    disabled: {
      type: Boolean,
      description: "Disables button entirely"
    },
    hover: {
      type: Boolean,
      description: "Manually control if the button is in its hover state"
    },
    active: {
      type: Boolean,
      description: "Manually control if the button is in its active state"
    },
    focused: {
      type: Boolean,
      description: "Manually control if the button is in its focused state"
    },
    border: {
      type: Boolean,
      description: "Adds a border to the button"
    },
    activeRing: {
      type: Boolean,
      default: !0,
      description: "Adds an active ring to the button when focused",
      editable: !1
    },
    loading: {
      type: Boolean,
      description: "Shows a spinner in the middle of the button, spinner inherits colors from theme prop"
    },
    stopPropagation: {
      type: Boolean,
      description: "Use the click events stopPropagation() method",
      editable: !1
    },
    preventDefault: {
      type: Boolean,
      description: "Use the click events preventDefault() method",
      editable: !1
    },
    tabindex: {
      type: String,
      default: "0",
      description: "The tabindex of the button",
      editable: !1
    }
  },
  emits: {
    click: {
      description: "Emitted when the button is clicked"
    }
  },
  setup(e, { emit: t }) {
    const r = t, c = e, f = l(() => {
      if (c.theme === "text-link")
        return "";
      if (c.icon)
        switch (c.size) {
          case "sm":
            return "w-[30px] h-[30px] rounded-button-sm";
          case "lg":
            return "w-10 h-10 rounded-button-lg";
          case "md":
          default:
            return "w-[38px] h-[38px] rounded-button-lg";
        }
      switch (c.size) {
        case "sm":
          return "button-sm text-sm px-button-x-sm py-button-y-sm leading-5 rounded-button-sm";
        case "lg":
          return "button-sm text-sm px-button-x-lg py-button-y-lg leading-5 rounded-button-lg";
        case "md":
        default:
          return "button-sm text-sm px-button-x-md py-button-y-md leading-5 rounded-button-lg";
      }
    });
    let h = l(() => {
      switch (c.theme) {
        case "primary":
        case "brand":
          return T;
        case "primary-subtle":
        case "brand-subtle":
          return C;
        case "base":
        case "secondary":
          return k;
        case "destructive":
          return x;
        case "destructive-subtle":
          return w;
        case "text-link":
          return D;
        case "transparent":
          return j;
        case "transparent-subtle":
          return M;
        case "transparent-subtle-invert":
          return P;
        case "outline":
          return $;
        case "superadmin":
          return U;
        case "input-alias":
          return z;
      }
    });
    const m = (b) => {
      c.preventDefault && b.preventDefault(), c.stopPropagation && b.stopPropagation(), !(c.disabled || c.loading) && r("click");
    };
    return (b, N) => (a(), n(s(d(h)), {
      tag: e.tag,
      class: o(["relative inline-flex items-center gap-x-1.5 cursor-pointer focus-visible:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 transition-colors duration-75", [d(f), {
        "justify-center": e.icon,
        "pointer-events-none cursor-not-allowed opacity-50": e.disabled,
        "pointer-events-none": e.loading,
        "flex-1 w-full justify-center": e.wide,
        "active:outline-none!": !e.activeRing,
        "outline-2 outline-offset-2 outline-(--border-brand-base)": e.focused
      }]]),
      disabled: e.disabled,
      tabindex: e.tabindex,
      hover: e.hover,
      active: e.active,
      focused: e.focused,
      border: e.border,
      "link-color": e.linkColor,
      "link-underline": e.linkUnderline,
      "link-size": e.linkSize,
      "d-group-border": "",
      "data-spark": "dbutton",
      "data-size": e.size,
      onClick: m
    }, {
      default: i(() => [
        y("span", {
          class: o(["inline-flex items-center gap-x-1.5 pointer-events-none", [e.loading ? "opacity-0" : "opacity-100"]])
        }, [
          e.leftIcon ? (a(), n(g, {
            key: 0,
            class: "-ml-0.5",
            icon: e.leftIcon,
            "icon-set": e.leftIconSet ?? e.iconSet,
            type: e.leftIconType ?? e.iconType,
            size: e.size === "sm" ? "w-4 h-4" : "w-5 h-5"
          }, null, 8, ["icon", "icon-set", "type", "size"])) : v("", !0),
          u(b.$slots, "default", {}, () => [
            y("div", A, [
              e.icon ? (a(), n(g, {
                key: 0,
                icon: e.icon,
                "icon-set": e.iconSet,
                type: e.iconType,
                size: e.iconSize,
                dot: e.dot
              }, null, 8, ["icon", "icon-set", "type", "size", "dot"])) : v("", !0)
            ])
          ]),
          e.rightIcon ? (a(), n(g, {
            key: 1,
            class: "-mr-0.5",
            icon: e.rightIcon,
            "icon-set": e.rightIconSet ?? e.iconSet,
            type: e.rightIconType ?? e.iconType,
            size: e.size === "sm" ? "w-4 h-4" : "w-5 h-5"
          }, null, 8, ["icon", "icon-set", "type", "size"])) : v("", !0)
        ], 2),
        e.loading ? (a(), p("span", E, [
          B(S, { active: e.loading }, null, 8, ["active"])
        ])) : v("", !0)
      ]),
      _: 3
    }, 8, ["tag", "class", "disabled", "tabindex", "hover", "active", "focused", "border", "link-color", "link-underline", "link-size", "data-size"]));
  }
};
export {
  O as _,
  z as a
};
